import PropTypes from "prop-types";
import React, { Component } from "react";
import { NavLink, Switch } from "react-router-dom";
// import ScrollAnimation from "react-animate-on-scroll";
import { Fade } from "react-reveal";
import Dropdown from "./mainMenuDropdown";

export default class MainMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeMobileMenu: false
		};
	}

	componentDidMount() {}
	componentWillUnmount() {}

	toggleMobileMenu = e => {
		e.preventDefault();
		let { activeMobileMenu } = this.state;
		this.setState({ activeMobileMenu: !activeMobileMenu });
	};

	render() {
		let { activeMobileMenu } = this.state;
		let { initClassName = "" } = this.props;
		// <li className="nav-item" style={{ color: "red" }}>
		//   <ScrollAnimation
		//     delay={2000}
		//     duration={3}
		//     animateIn="fadeIn"
		//     initiallyVisible={false}
		//   >
		//     <NavLink
		//       exact
		//       to="/"
		//       className="nav-link"
		//       activeClassName="active"
		//     >
		//       Home2
		//     </NavLink>
		//   </ScrollAnimation>
		// </li>
		return (
			<nav
				className={`navbar navbar-expand-lg navbar-dark position-fixed fixed-top w-100 ${initClassName} ${
					activeMobileMenu ? "mobile-active" : ""
				}`}>
				<div className="container">
					<NavLink exact to="/" className="mobile-logo-link">
						<img
							src="/images/logo/LogoGreenXGradient.svg"
							width="300"
							className="mobile-logo"
							rel="QwixSkinz"
						/>
					</NavLink>
					<button
						type="button"
						className="navbar-toggler"
						onClick={e => this.toggleMobileMenu(e)}>
						{activeMobileMenu ? (
							<img
								src="/images/fa/light/times-hexagon.svg"
								type="image/svg+xml"
								width="30"
								style={{ filter: "invert(1)" }}
							/>
						) : (
							<img
								src="/images/fa/light/bars.svg"
								type="image/svg+xml"
								width="30"
								style={{ filter: "invert(1)" }}
							/>
						)}
						{/* <span
              className={`fal fa-1x fa-fw ${
                activeMobileMenu ? "fa-times-hexagon" : "fa-bars"
              }`}
            /> */}
					</button>

					<div className="navbar-menu-wrap" id="mainmenu">
						<ul className="navbar-nav align-items-center justify-content-around w-100">
							<li className="d-lg-none close-mobile">
								<button
									type="button"
									className="mobile-close-menu"
									onClick={e => this.toggleMobileMenu(e)}>
									<img
										src="../images/fa/light/times-hexagon.svg"
										type="image/svg+xml"
										width="30"
										style={{ filter: "invert(1)" }}
									/>
									{/* <span
										className="fal fa-2x fa-fw fa-times-hexagon"
										style={{ color: "#ffffff" }}
									/> */}
								</button>
							</li>
							<li className="nav-item">
								<NavLink
									exact
									to="/"
									className="nav-link"
									activeClassName="active">
									Home
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink
									to="/history"
									className="nav-link"
									activeClassName="active">
									Our History
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink
									to="/research"
									className="nav-link"
									activeClassName="active">
									Research
								</NavLink>
							</li>

							<li className="nav-item logo">
								<NavLink exact to="/" className="menu-logo">
									<img
										width="300"
										src="/images/logo/LogoGreenXGradient.svg"
										rel="QwixSkinz"
									/>
								</NavLink>
							</li>

							<Dropdown title="Race Suits">
								<ul className="dropdown-menu" role="menu">
									<li>
										<NavLink
											to="/suits/alpine"
											className="nav-link"
											activeClassName="active">
											Alpine
										</NavLink>
									</li>
									<li>
										<NavLink
											to="/suits/bobsleigh"
											className="nav-link"
											activeClassName="active">
											Bobsleigh
										</NavLink>
									</li>
									<li>
										<NavLink
											to="/suits/luge"
											className="nav-link"
											activeClassName="active">
											Luge
										</NavLink>
									</li>
									<li className="divider" />
									<li>
										<NavLink
											to="/suits/skeleton"
											className="nav-link"
											activeClassName="active">
											Skeleton
										</NavLink>
									</li>
									<li>
										<NavLink
											to="/suits/speedskating"
											className="nav-link"
											activeClassName="active">
											Speed Skating
										</NavLink>
									</li>
								</ul>
							</Dropdown>

							<li className="nav-item">
								<NavLink
									to="/clubsuits"
									className="nav-link"
									activeClassName="active">
									Club Suits
								</NavLink>
							</li>
							{/*<Dropdown title="Club Suits">
                <ul className="dropdown-menu" role="menu">
                  <li className="nav-item">
                    <NavLink
                      to="/clubsuits"
                      className="nav-link"
                      activeClassName="active"
                    >
                      Club Suits
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      to="/suitbuilder"
                      className="nav-link"
                      activeClassName="active"
                    >
                      Suit Builder
                    </NavLink>
                  </li>
                </ul>
              </Dropdown>*/}

							<li className="nav-item">
								<NavLink
									to="/contact"
									className="nav-link"
									activeClassName="active">
									Contact
								</NavLink>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		);
	}
}
